import { TwoUpContent } from "@kohler-dsm-library/kohler-modules" // TODO: Replace with actual DS import
import { mapTwoUpContentProps } from "@/components/DesignSystem/mappers/twoUpContentMapper"

/**
 * Design System Component Registry
 *
 * Maps dsComponentType strings to their corresponding React components and
 * prop mappers. Used by getDSComponentForContainer to dynamically render
 * design system containers.
 *
 * @type {Object.<string, {component: React.ComponentType, mapper: Function}>}
 *
 */
export const dsComponentRegistry = {
  twoUpContent: {
    component: TwoUpContent, // TODO: Replace with actual DS component
    mapper: mapTwoUpContentProps,
  },
}
